// add suffix pending
export function withPending(action) {
  return `${action}_PENDING`;
}

// add suffix full filled
export function withFulFilled(action) {
  return `${action}_FULFILLED`;
}

// add suffix rejected
export function withRejected(action) {
  return `${action}_REJECTED`;
}
